/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Judges_LabelInputs */



/**
* | output |
* | --- |
* | "Sync judges" |
*
* @param {Admin_Sync_Judges_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_judges_label = /** @type {((inputs?: Admin_Sync_Judges_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Judges_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser les arbitres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar jueces")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronizar juízes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza i giudici")
	return /** @type {LocalizedString} */ ("Sync judges")
});